export default {
    topics: [
        {
            title: ' Example ',
            href: 'p-32.html',
            attributes: { 'data-id': 'p-32' },
            menu: { hasChildren: false },
            tocID: 'p-32-d66e7580',
            topics: [],
        },
        {
            title: 'Syntax',
            href: 'p-34.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e7588',
            next: 'tocId-d66e7588',
        },
        {
            title: 'Objects',
            href: 'c-Cookie.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e7613',
            next: 'tocId-d66e7613',
        },
    ],
};

